import type { Match } from "navigo";
import type { ChildDom } from "vanjs-core";
import { reactive } from "vanjs-ext";
import { errorSection } from "../error-section";
import { loadingScreen } from "../loading-screen";
import type { Route, RouteContext } from "../router";
import { centeredBox } from "../van/centered-box";
import { button, div, h1, p } from "../van/van-tags";

export class Sp2FactoryResetPage implements Route {
	async #factoryReset(): Promise<void> {
		errorSection.clear();

		const req = this.#ctx.api.put(
			`/smartplug2s/${this.#reactive.imei}/factory-reset`,
		);
		req.setSignedInUserAuth();

		const res = await loadingScreen.waitFor(req.do());
		if (res.ok) {
			this.#ctx.router.up();
		} else {
			errorSection.setText(await res.text());
		}
	}

	async refresh(match: Match): Promise<void> {
		if (!match?.data?.imei) throw "missing path param: imei";
		this.#reactive.imei = match.data.imei;
	}

	#ctx: RouteContext;
	#reactive = reactive({
		imei: "",
	});
	ChildDom: ChildDom;

	constructor(ctx: RouteContext) {
		this.#ctx = ctx;
		this.ChildDom = centeredBox(
			{
				size: "narrow",
			},
			h1({ class: "title is-4" }, "SmartPlug2 Factory Reset"),
			p({ class: "subtitle is-6" }, () => `IMEI ${this.#reactive.imei}`),
			div(
				{ class: "block" },
				p(
					"Resetting only affects the information kept about the ",
					"device in My.Luda.Farm. That is, it cancels any ",
					"subscription, removes all users from the device, and ",
					"enables the initial trial period, among other things. It ",
					"does not affect the hardware.",
				),
			),
			div(
				{ class: "buttons" },
				button(
					{
						class: "button is-primary",
						onclick: () => this.#factoryReset(),
					},
					"Reset",
				),
				button(
					{
						class: "button is-primary",
						onclick: () => this.#ctx.router.up(),
					},
					"Back",
				),
			),
		);
	}
}
